import { BorderBox, Stack } from '@trmediaab/zebra';
import { useCallback, useEffect, useState } from 'react';

import Modal from '../../../components/Modal';
import type { CheckoutState } from '../../../state';
import { useImmutableState } from '../../../state';
import useTicket from '../../../state/useTicket';
import { getProductLink, getProductSite } from '../../../utils/orderUtils';
import Confirm from './Confirm';
import Done from './Done';

interface PunchTicketModalProps {
  order: NonNullable<CheckoutState['order']>;
  onCancel: () => void;
}

const PunchTicketModal = ({ order, onCancel }: PunchTicketModalProps) => {
  const [ticket, error, isLoading, punchTicket] = useTicket(order);
  const { returnUrl, returnUrlText } = useImmutableState();
  const [step, setStep] = useState('confirm');
  const productLink = getProductLink(order, returnUrl, returnUrlText);
  const productSite = getProductSite(order);

  const onPunchClick = useCallback(() => {
    setStep('done');
    punchTicket();
  }, [punchTicket]);

  useEffect(() => {
    if (error != null) {
      setStep('confirm');
    }
  }, [error]);

  if (ticket == null || productLink == null || productSite == null) {
    return null;
  }

  return (
    <Modal>
      <BorderBox
        border="1"
        borderRadius="3px"
        boxShadow="checkout.box"
        bg="background.primary"
        maxWidth="360px"
        mx="auto"
        px={[3, null, '3,5']}
        py="4"
      >
        <Stack between={['2,5', null, 3]}>
          {step === 'confirm' && (
            <Confirm
              ticket={ticket}
              error={error}
              onPunch={onPunchClick}
              onCancel={onCancel}
            />
          )}
          {step === 'done' && (
            <Done
              isLoading={isLoading}
              site={productSite}
              hrefUrl={productLink[0]}
              hrefText={productLink[1]}
            />
          )}
        </Stack>
      </BorderBox>
    </Modal>
  );
};

export default PunchTicketModal;
